// src/pages/ViewLabTests.jsx
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { FlaskConical, Calendar, FileCheck2, Captions } from "lucide-react";

const ViewLabTests = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [labTests, setLabTests] = useState([]);
  const location = useLocation();



  const fetchLabTests = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        `https://www.careplus.gopillz.com/lab_book_details`,
        JSON.stringify({ id: patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setLabTests(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch lab tests. Try again later.");
        console.error(error);
      }
    }
  };

  useEffect(() => {
    fetchLabTests()
  }, []);

  const formatStatus = (status) => {
    console.log(status, "status")
    if (status === "1") return { text: "Proposed", className: "bg-yellow-100 text-yellow-800" };
    if (status === "2") return { text: "Confirmed", className: "bg-green-100 text-green-700" };
    if (status==="confirmed") return { text: "Confirmed", className: "bg-green-100 text-green-700" };
    return { text: "Unknown", className: "bg-gray-200 text-gray-700" };
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <Navbar />

      <div className="p-6 max-w-6xl mx-auto w-full">
        <h2 className="text-3xl font-bold text-blue-900 text-center mb-8 mt-6 sm:mt-10">
          🧪 Patient Lab Tests
        </h2>

        {labTests.length === 0 ? (
          <div className="text-3xl font-bold text-blue-900 text-center mb-8 mt-6 sm:mt-10">
            No lab tests available.
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {labTests.map((test) => {
                 const { text, className } = formatStatus(test.status);
                 return ( <div 
                key={test.id}
                className="bg-white shadow-md rounded-2xl p-5 border border-blue-100 hover:shadow-xl transition duration-300"
              >
                <div className="flex items-center gap-3 mb-3">
                  <FlaskConical className="text-blue-600 w-5 h-5" />
                  <h3 className="text-lg font-semibold text-blue-800">
                    {test.test_name}
                  </h3>
                </div>

                <div className="flex items-center text-sm text-gray-600 mb-2">
                  <Calendar className="w-4 h-4 mr-2" />
                  <span>{new Date(test.date).toLocaleDateString()}</span>
                </div>

                {/* <div className="flex items-center text-sm text-gray-600 mb-2">
                  <FileCheck2 className="w-4 h-4 mr-2" />
                  <span>
                    Result:{" "}
                    <span className="font-medium text-gray-800">
                      {test.result || "Pending"}
                    </span>
                  </span>
                </div> */}

                <div className="mt-3">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${className}`}
                  >
                    {text}
                  </span>
                </div>
              </div>
                 )
})}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewLabTests;
